import Swal from "sweetalert2";

export async function triggerAlert({titleAlert = null, bodyAlert = null, typeAlert = "success", showButton = false}) {
    if (!titleAlert && !bodyAlert) {
        console.error("The title and the body of the message are empty");
        return;
    }
    return await Swal.fire({
        title: titleAlert,
        html: bodyAlert,
        icon: typeAlert,
        showConfirmButton: showButton,
        timer: 3500
    })

}